(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/freja/freja-main.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/freja/freja-main.js');

'use strict';

const {
  useEffect
} = React;
const {
  FrejaStart
} = svs.iam_login.components.freja;
const {
  PollingMobile,
  PollingDesktop,
  Loading
} = svs.iam_login.components.shared;
const {
  useAtomValue
} = jotai;
const {
  isPollingAtom,
  isNewCustomerAtom,
  loginCompletedAtom
} = svs.iam_login.atoms;
const login = svs.iam_login.utils.Login;
const FrejaMain = _ref => {
  let {
    showQR
  } = _ref;
  const isPolling = useAtomValue(isPollingAtom);
  const isNewCustomer = useAtomValue(isNewCustomerAtom);
  const loginCompleted = useAtomValue(loginCompletedAtom);
  const PollingComponent = showQR ? PollingDesktop : PollingMobile;
  useEffect(() => {
    if (showQR && !loginCompleted) {
      login.start(isNewCustomer);
    }
  }, [showQR, isNewCustomer, loginCompleted]);
  if (loginCompleted) {
    return React.createElement(Loading, null);
  }
  return isPolling && !showQR ? React.createElement(PollingComponent, null) : React.createElement(FrejaStart, {
    isNewCustomer: isNewCustomer,
    showQR: showQR
  });
};
svs.iam_login.components.freja.FrejaMain = FrejaMain;

 })(window);